var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Performs a PUT request against a given signed url and file
 * @function uploadWithSignedUrl
 * @param data
 * A payload containing an array of headers and a signed url
 * @param file
 * The file object to upload
 */
function uploadWithSignedUrl(data, file) {
    return __awaiter(this, void 0, void 0, function* () {
        const headerRecord = {
            'Content-Type': file.type,
        };
        // Always send through the signed URL headers (x-goog-meta-*), otherwise the upload will be rejected.
        data.headers.forEach((header) => (headerRecord[header.key] = header.value));
        return fetch(data.signedURL, {
            method: 'PUT',
            headers: headerRecord,
            body: file,
        });
    });
}
/**
 * @function uploadFile
 * Uploads the file via SignedURL
 * @param uploadSignature
 * A payload containing an array of headers and a signed url
 * @param file
 * The file to upload
 */
export const uploadFile = (uploadSignature, file) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield uploadWithSignedUrl(uploadSignature, file);
    if (!response.ok || response.status !== 200) {
        const message = yield response.text();
        throw new Error(message);
    }
    return file;
});
